import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../contexts/AuthContext'
import { useFetch } from '../useFetch'

import { CONFIG } from '../../config'
import { CourtModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useCourtsByClub() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const courtsByClub = async (clubId: number) => {
    setLoading(true)
    try {
      const data = await fetcher<CourtModel[]>(
        `${CONFIG.BOUNCE_API}/api/v1/clubs/${clubId}/courts`
      )
      if (data) {
        setError(null)
        return data
      }
    } catch (caughtError) {
      console.log(caughtError)
      if (caughtError instanceof ApiError) {
        setError(getErrorMessage(caughtError.data))
      } else {
        setError(t('exceptions:unknown'))
      }
    } finally {
      setLoading(false)
    }
  }

  return { courtsByClub, loading, error, resetState }
}
